"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node, event, handler, capture) {
  node.addEventListener(event, handler, capture);
  return {
    remove: function remove() {
      node.removeEventListener(event, handler, capture);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/utils/addEventListener.js
// module id = 305
// module chunks = 4220841425358 102538987983895